export default __webpack_public_path__ + "static/garden_design9-0dfe566aabb5bd66bd82c99616bf50a5.webp";